import InventoriRegister from "pages/Inventori/Register"
import Journal from "pages/Finance/Journal"
import Find from "pages/FindSection"
import ApproveTransfer from "pages/Inventori/Transaction/ApproveTransfer"
import {
  CreatePage,
  CreatePageTwo
} from "../pages/Inventori/Transaction/AddNewItem/components"
import {
  DetailPage,
  UpdateItemPage
} from "../pages/Inventori/Transaction/AddNewItem/components/ChildItem/components/Item/components"
import TransferItems from "pages/Inventori/Transaction/TransferItem"
import TransferItemsEdit from "pages/Inventori/Transaction/TransferItem/Edit"
import TransferList from "pages/Inventori/Transaction/TransferItem/List"
import Received from "pages/Inventori/Transaction/Received"
import ReceivedEdit from "pages/Inventori/Transaction/Received/Edit"
import ApproveReceived from "pages/Inventori/Transaction/ApproveReceived"
import ApproveAdjustment from "pages/Inventori/Transaction/ApproveAdjustment"
import BuildItem from "pages/Inventori/Transaction/BuildItem"
import EditBuildItem from "pages/Inventori/Transaction/BuildItem/EditBuildItem"
import Dashboard from "pages/Inventori/Dashboard"
import BuiltItem from "pages/Inventori/Transaction/BuiltItem"
import AdjustmentInventory from "pages/Inventori/Transaction/AdjustmentInventory"
import CreateAdjustmentInventory from "pages/Inventori/Transaction/AdjustmentInventory/Create"
import CountInventory from "pages/Inventori/Transaction/CountInventory"
import EditCountInventory from "pages/Inventori/Transaction/CountInventory/Edit"
import ApproveBuild from "pages/Inventori/Transaction/ApproveBuild"
import SetItemPrice from "pages/Inventori/Transaction/SetItemPrice"
import { EditAdjustmentInventory } from "pages/Inventori/Transaction/AdjustmentInventory/Edit"
import PricingAnalyse from "pages/Inventori/Report/PricingAnalyse"
import type { RouteType } from "types"
import SetStockByLocation from "pages/Inventori/Transaction/SetStockByLocation"
import SetStockGlobal from "pages/Inventori/Transaction/SetStockGlobal"
import { StockAlertListPage } from "pages/Inventori/Report/StockAlert/StockAlertListPage"
import ItemDetaiStockGlobal from "pages/Inventori/Report/ItemDetailStockGlobal"
import ItemBuildReportPage from "pages/Inventori/Report/ItemBuild"
import ItemDetailStockLocation from "pages/Inventori/Report/ItemDetailStockLocation"
import { PERMISION } from "security"
import { PromiseToCome } from "pages/Inventori/Dashboard/PromiseToCome"
import { InventoryTurnoverPage } from "pages/Inventori/Dashboard/InventoryTurnover"
import { CurrentStockPosition } from "pages/Inventori/Dashboard/CurrentStockPosition"
import { CustomerOrderFullfilment } from "pages/Inventori/Dashboard/CustomerOrderFullfillment"
import { CurrentStockPerformance } from "pages/Inventori/Dashboard/CurrentStockPerformance"
import ListItemSummary from "pages/Inventori/Report/ListItemSummary"
import InventoryMovementReport from "pages/Inventori/Report/InventoryMovement"

export const inventoryRoutes: RouteType[] = [
  {
    path: "/inventory/register",
    element: <InventoriRegister />,
    permission: PERMISION.INVENTORY.REGISTER.PERMISION
  },
  {
    path: "/inventory/transaction/add-new-item",
    element: <CreatePage />,
    permission: PERMISION.INVENTORY.REGISTER.REGISTER_GROUP.CREATE || PERMISION.INVENTORY.TRANSACTION.CREATE_ITEM.CREATE
  },
  {
    path: "/inventory/transaction/add-new-items",
    element: <CreatePageTwo />,
    permission: PERMISION.INVENTORY.REGISTER.REGISTER_GROUP.CREATE
  },
  {
    path: "/inventory/transaction/add-new-item/update/:id",
    element: <UpdateItemPage />,
    permission: PERMISION.INVENTORY.REGISTER.REGISTER_GROUP.UPDATE
  },
  {
    path: "/inventory/transaction/add-new-item/detail",
    element: <DetailPage />,
    permission: PERMISION.INVENTORY.REPORT.PRICING_ANALYSE.READ
  },
  {
    path: "/inventory/transaction/transfer-items",
    element: <TransferItems />,
    permission: PERMISION.INVENTORY.TRANSACTION.CREATE_TRANSFER_ITEM.CREATE
  },
  {
    path: "/inventory/transaction/transfer-items/edit/:transfer_id",
    element: <TransferItemsEdit />,
    permission: PERMISION.INVENTORY.REGISTER.TRANSFER.UPDATE
  },
  {
    path: "/inventory/transaction/approve-transfer",
    element: <ApproveTransfer />,
    permission: PERMISION.INVENTORY.TRANSACTION.APPROVAL_TRANSFER_ITEM.READ
  },
  {
    path: "/inventory/transaction/approve-received",
    element: <ApproveReceived />,
    permission: PERMISION.INVENTORY.TRANSACTION.APPROVAL_RECEIVED_ITEM.READ
  },
  {
    path: "/inventory/transaction/received/transfer-list",
    element: <TransferList />,
    permission: PERMISION.INVENTORY.TRANSACTION.CREATE_RECEIVED_ITEM.READ
  },
  {
    path: "/inventory/transaction/received/:transfer_id",
    element: <Received />,
    permission: PERMISION.INVENTORY.TRANSACTION.CREATE_RECEIVED_ITEM.UPDATE
  },
  {
    path: "/inventory/transaction/received/edit/:received_id",
    element: <ReceivedEdit />,
    permission: PERMISION.INVENTORY.REGISTER.RECEIVED.UPDATE
  },
  {
    path: "/inventory/transaction/approve-adjustment",
    element: <ApproveAdjustment />,
    permission: PERMISION.INVENTORY.TRANSACTION.APPROVAL_ADJUSTMENT_ITEM.READ
  },
  {
    path: "/inventory/transaction/built-inventori",
    element: <BuiltItem />,
    permission: PERMISION.INVENTORY.TRANSACTION.CREATE_BUILD_ITEM.CREATE
  },
  {
    path: "/inventory/transaction/build-item/:product_id",
    element: <BuildItem />,
    permission: PERMISION.INVENTORY.REPORT.ITEM_DETAIL_STOCK_GLOBAL.UPDATE
  },
  {
    path: "/inventory/transaction/build-item/edit/:build_id",
    element: <EditBuildItem />,
    permission: PERMISION.INVENTORY.REGISTER.BUILD_ITEM.UPDATE
  },
  {
    path: "/inventory/transaction/count-inventory",
    element: <CountInventory />,
    permission: PERMISION.INVENTORY.TRANSACTION.CREATE_COUNT_ITEM.CREATE
  },
  {
    path: "/inventory/transaction/count-inventory/edit/:id",
    element: <EditCountInventory />,
    permission: PERMISION.INVENTORY.REGISTER.COUNT.UPDATE
  },
  {
    path: "/inventory/transaction/adjustment-inventory",
    element: <AdjustmentInventory />,
    permission: PERMISION.INVENTORY.TRANSACTION.CREATE_ADJUSTMENT_ITEM.CREATE
  },
  {
    path: "/inventory/transaction/adjustment-inventory/create/:count_id",
    element: <CreateAdjustmentInventory />,
    permission: PERMISION.INVENTORY.TRANSACTION.CREATE_COUNT_ITEM.CREATE
  },
  {
    path: "/inventory/transaction/adjustment-inventory/edit/:adjustment_id",
    element: <EditAdjustmentInventory />,
    permission: PERMISION.INVENTORY.REGISTER.ADJUSTMENT.UPDATE
  },
  {
    path: "/inventory/transaction/approve-build",
    element: <ApproveBuild />,
    permission: PERMISION.INVENTORY.TRANSACTION.APPROVAL_BUILD.READ
  },
  {
    path: "/inventory/transaction/set-item-price",
    element: <SetItemPrice />,
    permission: PERMISION.INVENTORY.TRANSACTION.SET_ITEM_PRICE.READ
  },
  {
    path: "/inventory/transaction/set-stock-by-location",
    element: <SetStockByLocation />,
    permission: PERMISION.INVENTORY.TRANSACTION.SET_STOCK_BY_LOCATION.READ
  },
  {
    path: "/inventory/transaction/set-stock-global",
    element: <SetStockGlobal />,
    permission: PERMISION.INVENTORY.TRANSACTION.SET_STOCK_GLOBAL.READ
  },
  {
    path: "/inventory/journal",
    element: <Journal />,
    permission: PERMISION.INVENTORY.JOURNAL.PERMISION
  },
  {
    path: "/inventory/find",
    element: <Find />,
    permission: PERMISION.INVENTORY.FIND.PERMISION
  },
  {
    path: "/inventory/report/dashboard",
    element: <Dashboard />,
    permission: PERMISION.INVENTORY.REPORT.DASHBOARD.READ
  },
  {
    path: "/inventory/report/dashboard/promise-to-come",
    element: <PromiseToCome />,
    permission: PERMISION.INVENTORY.REPORT.DASHBOARD.READ
  },
  {
    path: "/inventory/report/dashboard/inventory-turnover",
    element: <InventoryTurnoverPage />,
    permission: PERMISION.INVENTORY.REPORT.DASHBOARD.READ
  },
  {
    path: "/inventory/report/dashboard/current-stock-position",
    element: <CurrentStockPosition />,
    permission: PERMISION.INVENTORY.REPORT.DASHBOARD.READ
  },
  {
    path: "/inventory/report/dashboard/customer-order-fullfilment",
    element: <CustomerOrderFullfilment />,
    permission: PERMISION.INVENTORY.REPORT.DASHBOARD.READ
  },
  {
    path: "/inventory/report/dashboard/current-stock-performance",
    element: <CurrentStockPerformance />,
    permission: PERMISION.INVENTORY.REPORT.DASHBOARD.READ
  },
  {
    path: "/inventory/report/stock-alert",
    element: <StockAlertListPage />,
    permission: PERMISION.INVENTORY.REPORT.STOCK_ALERT.READ
  },
  {
    path: "/inventory/report/list-detail-stock-location",
    element: <ItemDetailStockLocation />,
    permission: PERMISION.INVENTORY.REPORT.ITEM_DETAIL_STOCK_BY_LOCATION.READ
  },
  {
    path: "/inventory/report/pricing-analyse",
    element: <PricingAnalyse/>,
    permission: PERMISION.INVENTORY.REPORT.PRICING_ANALYSE.READ
  },
  {
    path: "/inventory/report/item-detail-stock-global",
    element: <ItemDetaiStockGlobal/>,
    permission: PERMISION.INVENTORY.REPORT.ITEM_DETAIL_STOCK_GLOBAL.READ
  },
  {
    path: "/inventory/report/item-build",
    element: <ItemBuildReportPage />,
    permission: PERMISION.INVENTORY.REPORT.BUILD_COMPONENT.READ
  },
  {
    path: "/inventory/transaction",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/transaction/item-register",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/transaction/set-item-price",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/transaction/transfer-inventory",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/report/list-item-summary",
    element: <ListItemSummary />,
    permission: PERMISION.INVENTORY.REPORT.ITEM_LIST_SUMMARY.PERMISION
  },
  {
    path: "/inventory/report/list-item-detail",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/report/list-item-transaction",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/report/analyse-inventory-summary",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/report/analyse-inventory-detail",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/report/build-component",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/report/inventory-movement",
    element: <InventoryMovementReport />,
    permission: PERMISION.INVENTORY.REPORT.ITEM_LIST_SUMMARY.PERMISION
  },
  {
    path: "/inventory/report/inventory-count-sheet",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/report/pricing-summary",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  },
  {
    path: "/inventory/report/inventory-journal",
    element: <div />,
    permission: PERMISION.INVENTORY.FIND.PERMISION /** Hak akses belum di setup karena menu belum di develope */
  }
]
